import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Input from 'components/react-validation/components/input';
import * as Vali from '../../helper/validator-helper';
import * as UserActionType from '../constants';
import { InviteTenantUser } from '../Components/invite-tenant-user';
import { InviteNonSystemUser } from '../Components/invite-nonsystem-user';
import { InviteSystemUser } from '../Components/invite-system-user';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import {
  Row,
  Col
} from 'react-bootstrap';
import '../invite-user.scss';
import { AppSettings } from '../../constants';

class InviteUser extends Component {
  static propTypes = {
    errorMsg: PropTypes.array,
    selectListRooms: PropTypes.array,
    InviteUser: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    UserProfile: PropTypes.object,
    UserProfileByEmail: PropTypes.object,
    ManageUser: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      email: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.InviteUser.IsBack) {
      this.props.history.goBack();
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: UserActionType.RESET_INVITE_USER });
  }

  onSearch = (e) => {

    var data = this.form.getValues();

    this.props.dispatch({
      type: UserActionType.GET_USER_BY_EMAIL_ASYNC,
      params: data.email.trim()
    });

    e.preventDefault();
  }

  onBack = () => {
    this.props.dispatch({ type: UserActionType.RESET_INVITE_USER });
  }

  onSave = (e, item, userActionType) => {
    var searchParam = this.props.ManageUser.params;
    this.props.dispatch({
      type: userActionType,
      params: {
        data: item,
        search: {
          email: '',
          sortField: searchParam.sort.field,
          sortOrder: searchParam.sort.order,
          status: 'all',
          skip: 0,
          take: 10
        }
      }
    });
  }

  userPageUrl = () => {
    if (AppSettings.clientTypeValue === 'Builder') {
      return '/users';
    }

    return '/';
  }

  render() {

    const breadcrumbs = [
      {title: 'Users', url: this.userPageUrl()},
      {title: 'Invite new user', url: ''}
    ];

    return <div className='wrapper'>
      <div className='page-title'>
        <h2>Invite new user</h2>
      </div>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <div className='box-form-siteone'>
        <div className={this.props.InviteUser.IsHiddenSearchEmail ? 'cls-hidden' : ''}>
          <Form ref={c => { this.form = c; }} onSubmit={this.onSearch}>
            <div className='box-form-body'>
              <Row>
                <Col md={6} sm={6}>
                  <div className='form-group'>
                    <label>Please enter the email address you want to send invitation <span className='text-danger'>*</span></label>
                    <Input type='text'
                      name='email'
                      autoFocus
                      placeholder='Email address'
                      className='form-control'
                      maxLength='256'
                      max='256'
                      validations={[Vali.required, Vali.email, Vali.maxlength]} />
                  </div>
                  <div className='form-group text-left'>
                    <Submit className='btn btn-primary btn-siteone'>Next</Submit>
                  </div>
                </Col>
              </Row>

            </div>
          </Form>

        </div>

        <InviteSystemUser
          isHidden={this.props.InviteUser.IsHiddenSystemUser}
          onBack={this.onBack}
          onSave={this.onSave}
          userProfile={this.props.UserProfileByEmail} />

        <InviteTenantUser
          isHidden={this.props.InviteUser.IsHiddenTenantUser}
          onBack={this.onBack}
          userProfile={this.props.UserProfileByEmail} />
        <InviteNonSystemUser
          isHidden={this.props.InviteUser.IsHiddenNonSystemUser}
          onBack={this.onBack}
          onSave={this.onSave}
          userProfile={this.props.UserProfileByEmail} />
      </div>
    </div>;

  }
}
const mapStateToProps = (state) => {
  return state.UserStore;
};

export default connect(mapStateToProps)(InviteUser);



// WEBPACK FOOTER //
// ./src/User/Containers/invite-user.js